/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <gnu.org/licenses>.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <l-map
    v-if="showCard"
    :ref="'map'"
    style="height: 200px"
    :center="center"
    :zoom="zoom"
    :maxZoom="maxZoom"
    :bounds="bounds"
    :options="optionsCard"
  >
    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
    <div v-if="bounds && LPolyline">
    <l-polyline v-for="(polyline, index) in  LPolyline" :lat-lngs="polyline.latlng" :color="'blue'">
      <l-popup v-if="polyline.data"
        :content="'<div style=\'min-width: 220px;\'><div class=\'text-center\' ><b>'+ (polyline.data.user ? polyline.data.user.givenName : polyline.data.carpoolerFirstName) + ' ' + (polyline.data.user ? polyline.data.user.shortFamilyName : polyline.data.carpoolerLastName )+'</b></div><br>' +
         ('<div><b>Départ</b> : ' +  (polyline.data.outwardWaypoints ? polyline.data.outwardWaypoints[0].address.addressLocality : polyline.data.origin.addressLocality) + '</div>') +
         ('<div><b>Destination</b> : ' + (polyline.data.outwardWaypoints ? polyline.data.outwardWaypoints[polyline.data.outwardWaypoints.length - 1].address.addressLocality : polyline.data.destination.addressLocality) + '</div>')  +
        '<br><div><ion-button onclick=\'goToSearch('+ JSON.stringify(polyline.data) +')\' size=\'small\'>Chercher les correspondances</ion-button></div></div>'"
        :options="{ autoClose: true, closeOnClick: false }"
      ></l-popup>
    </l-polyline>
    </div>
    <div v-if="bounds && LMarker">
      <l-marker v-for="(marker, index) in  LMarker" :lat-lng="marker.latlng" :key="index">
        <l-popup v-if="marker.name"
          :content="'<div><b>'+marker.name+'</b></div>' + (marker.type === 'relaypoint' && marker.address ? ('<br><div>Sélectionner ce point relais comme :</div><div><ion-button expand=\'full\' onclick=\'selectOrigin('+ JSON.stringify(marker) +')\' size=\'small\'>Origine</ion-button></div><div><ion-button expand=\'full\' onclick=\'selectDestination('+ JSON.stringify(marker) +')\' size=\'small\'>Destination</ion-button></div>') : '')"
          :options="{ autoClose: true, closeOnClick: false }"
        ></l-popup>
      </l-marker>
    </div>
  </l-map>
</template>

<style lang="scss">
</style>

<script>
import { LMap, LMarker, LTileLayer, LPolyline, LPopup } from "vue2-leaflet";
import {isPlatform} from "@ionic/core";
import { address } from "../../../Shared/Mixin/address.mixin";

export default {
  name: "mini-map",
  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution: '<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      zoom: 5,
      maxZoom: 10,
      center: [47.2350952, 2.0426357],
      showCard: true,
      optionsCard: {
        dragging: !isPlatform(window.document.defaultView, "mobile"),
        touchZoom: isPlatform(window.document.defaultView, "mobile"),
        tap: !isPlatform(window.document.defaultView, "mobile"),
        fullscreenControl: {
          pseudoFullscreen: true
        }
      }
    };
  },
  mixins: [address],
  components: {
    LMap,
    LTileLayer,
    LPolyline,
    LMarker,
    LPopup
  },
  props: ["LPolyline", "LMarker", 'communities'],
  mounted() {
    setTimeout(() => {
      if (!!this.$refs.map) this.$refs.map.mapObject.invalidateSize();
    }, 100);

    setTimeout(() => {
      this.maxZoom = 18;
    }, 1000);

    window.goToSearch = function (event) {
      let addressDTOOrigin = event.outwardWaypoints ? event.outwardWaypoints[0].address : event.origin;
      const displayGeoOrigin = this.formatAddress(event.outwardWaypoints ? event.outwardWaypoints[0].address : event.origin)
      let addressDTODestination = event.outwardWaypoints ? event.outwardWaypoints[event.outwardWaypoints.length -1].address : event.destination
      const displayGeoDestination = this.formatAddress(event.outwardWaypoints ? event.outwardWaypoints[event.outwardWaypoints.length -1].address : event.destination)
      this.$store.commit("changeOrigin", {
        addressDTO: addressDTOOrigin,
        displayGeo: displayGeoOrigin
      });
      this.$store.commit("changeDestination", {
        addressDTO: addressDTODestination,
        displayGeo: displayGeoDestination
      });

      /*
      this.$store.state.searchStore.searchObject.frequency = event.regular ? 2 : 1;
      this.$store.state.searchStore.searchObject.adId = event.proposalId;
       */
      let filters = null;
      if (this.communities && this.communities.length > 0) {
        filters = {communities: this.communities};
      }
      this.$router.push({ name: "search", params: {filters} });
    }.bind(this);

    window.selectOrigin = function (event) {
      console.log(event)
      const addressDTO = event.address;
      const displayGeo = this.formatAddress(event.address)
      this.$store.commit("changeOrigin", { addressDTO, displayGeo });
    }.bind(this);

    window.selectDestination = function (event) {
      console.log(event)
      const addressDTO = event.address;
      const displayGeo = this.formatAddress(event.address)
      this.$store.commit("changeDestination", { addressDTO, displayGeo });
    }.bind(this);
  },
  computed: {
    bounds() {
      let bounds;
      if (this.LMarker && this.LMarker.length > 0) bounds = new L.LatLngBounds(this.LMarker.map(item => item.latlng));
      if (this.LPolyline && this.LPolyline.length > 0) bounds = new L.LatLngBounds(this.LPolyline.map(item => item.latlng));
      if (!!this.$refs.map) this.$refs.map.mapObject.invalidateSize();
      return bounds;
    }
  },
  methods: {
    maxiCard: function() {},
  }
};
</script>
